import servise from '@/router/axios'

export const addAdChannel = (data) => {
  return servise({
    url: '/slot/channel',
    method: 'post',
    data
  })
}

export const updateAdChannel = (data) => {
  return servise({
    url: '/slot/channel',
    method: 'put',
    data
  })
}

export const getAdChannelDetail = (params) => {
  return servise({
    url: '/slot/channel',
    method: 'get',
    params
  })
}
